import actionTypes from "../../actions/actionTypes";

const initialState = {
  rolesAndPermissions: null,
  createRoleLoader: null,
  postRoleLoader: null,
  roleNameCheckLoader: null,
};

const rolesAndPermissionsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.adminTypes.rolesAndPermissionsTypes
      .SET_ROLES_AND_PERMISSIONS:
      return {
        ...state,
        rolesAndPermissions: payload,
      };
    case actionTypes.adminTypes.rolesAndPermissionsTypes.SET_CREATE_ROLE_LOADER:
      return {
        ...state,
        createRoleLoader: payload,
      };
    case actionTypes.adminTypes.rolesAndPermissionsTypes.SET_POST_ROLE_LOADER:
      return {
        ...state,
        postRoleLoader: payload,
      };
    case actionTypes.adminTypes.rolesAndPermissionsTypes
      .SET_ROLE_NAME_CHECK_LOADER:
      return {
        ...state,
        roleNameCheckLoader: payload,
      };
    default:
      return state;
  }
};

export default rolesAndPermissionsReducer;
